<p-dialog header="Administrar carpetas"
          [visible]="isVisible"
          (visibleChange)="!$event && close()"
          [modal]="true"
          [style]="{width: '620px'}"
          [draggable]="false"
          [resizable]="false">

  <p-messages severity="info" [closable]="false" styleClass="mb-2">
    <ng-template pTemplate>
      <small>
        Marca las carpetas que quieres ver en el buzón. La selección se guarda en el servidor de correo, así que
        también afecta al webmail y a cualquier otro programa que use esta cuenta.
      </small>
    </ng-template>
  </p-messages>

  <p-messages *ngIf="error" severity="error" [closable]="false">
    <ng-template pTemplate>
      <div class="flex flex-column gap-2">
        <span>{{error.message}}</span>
        <p-button *ngIf="error.retryable" label="Reintentar" icon="pi pi-refresh" size="small" [text]="true"
                  (click)="load()"></p-button>
      </div>
    </ng-template>
  </p-messages>

  <div class="p-inputgroup input-field mb-2">
    <input pInputText [(ngModel)]="filter" placeholder="Filtrar carpetas" />
    <p-button *ngIf="filter" icon="pi pi-times" severity="secondary" (click)="filter = ''"></p-button>
  </div>

  <div class="folders-manager-list">
    <div *ngIf="loading" class="p-3">
      <p-skeleton width="100%" styleClass="mb-2" *ngFor="let placeholder of [1,2,3,4,5,6]"></p-skeleton>
    </div>

    <div *ngIf="!loading">
      <div *ngFor="let row of visibleFolders" class="folder-row" [class.folder-row-fixed]="!row.folder.canChangeSubscription">
        <p-inputSwitch [ngModel]="row.folder.subscribed"
                       [disabled]="!row.folder.canChangeSubscription || row.saving"
                       (click)="toggle(row)"></p-inputSwitch>

        <i [class]="iconFor(row.folder)" [style.margin-left.rem]="row.folder.depth * 0.9"></i>

        <div class="folder-row-name">
          <div>{{row.displayName}}</div>
          <small class="text-color-secondary" *ngIf="row.displayName !== row.folder.path">{{row.folder.path}}</small>
        </div>

        <small class="text-color-secondary" *ngIf="row.folder.total !== null">
          {{row.folder.total}} {{row.folder.total === 1 ? 'mensaje' : 'mensajes'}}
        </small>

        <p-tag *ngIf="!row.folder.canChangeSubscription" value="Siempre visible" severity="secondary"></p-tag>
        <p-tag *ngIf="!row.folder.selectable" value="No contiene correo" severity="warn"></p-tag>
      </div>

      <div *ngIf="visibleFolders.length === 0" class="p-3 text-center text-color-secondary">
        Ninguna carpeta coincide con el filtro.
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex align-items-center w-full">
      <small class="text-color-secondary">{{subscribedCount}} de {{folders.length}} carpetas visibles</small>
      <div class="flex-grow-1"></div>
      <p-button label="Cerrar" icon="pi pi-check" (click)="close()"></p-button>
    </div>
  </ng-template>
</p-dialog>
